import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { type FC, useCallback } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import { FilterDropdown } from "~/components/UI/FilterDropdown";
import { SubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard";
import { useSubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard/useSubscriptionGuard";
import { RoiFilterEnum } from "~/types/roi";
import { FeatureKey } from "~/types/subscription";

import { ROI_TOOLTIP_TEXT, roiFilterOptions } from "./constants";

export const RoiFilter: FC = () => {
  const { filters, updateFilters } = useFiltersScope();
  const { isLocked } = useSubscriptionGuard(FeatureKey.ROI_FILTER);

  const onChange = useCallback(
    (roiFilter?: RoiFilterEnum) => {
      updateFilters({ roiFilter });
    },
    [updateFilters]
  );

  return (
    <SubscriptionGuard featureKey={FeatureKey.ROI_FILTER}>
      <FilterDropdown
        label="Min ROI"
        icon={<CurrencyExchangeIcon fontSize="inherit" />}
        tooltip={ROI_TOOLTIP_TEXT}
        locked={isLocked}
        options={roiFilterOptions}
        defaultValue={RoiFilterEnum.ALL}
        value={filters.roiFilter ?? RoiFilterEnum.ALL}
        onChange={onChange}
      />
    </SubscriptionGuard>
  );
};
